import { swymFetch } from '~/services/fetch-swym'

import { communitiesParser } from '~/entities/container/community/api/parser-community'
import type { ICommunity } from '~/entities/container/community/interfaces/community'

import type { SwymService } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

export const CommunityExploreSwymService: SwymService<ICommunity> = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll(params) {
    const url = '/api/community/discovercommunities'

    const response = await swymFetch.post(url, {
      json: {
        params: {
          limit: params.limit,
          page: params.page,
        },
      },
    })
      .json<SwymResponse<ICommunity[]>>()
      .then(communitiesParser)

    return {
      data: response.result,
      total: response.result.length,
    }
  },
}
